export default {"src":"/_next/static/media/googleCalendarIcon.e3113b61.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};